import axios from 'axios';

const instance = axios.create({
    url:'http://13.233.195.147'
});

export default instance;
